export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const SESSION_EXPIRE = "SESSION_EXPIRE";
export const USER_LOGOUT = "USER_LOGOUT";
export const EDIT_USER_DATA = "EDIT_USER_DATA";

